(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function mobileToggler(x) {
    if (x.matches) {
      document.querySelectorAll('.mobile-toggler').forEach(item => item.addEventListener('click', (event) => {
        event.preventDefault();
        let toggler = event.currentTarget.classList;
        toggler.contains('toggled') ? toggler.remove('toggled') : toggler.add('toggled');
      }));
    }
  }
  var x = window.matchMedia("(max-width: 991px)")
  mobileToggler(x);
  x.addListener(mobileToggler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const mega_menu_overlay = document.querySelector('#mega-menu-overlay');
  const elements = document.querySelectorAll('header-menu');

  elements.forEach((element) => {
    element.addEventListener('mouseover', handleMouseOver);
    element.addEventListener('mouseout', handleMouseOut);
  });

  function handleMouseOver(event) {
    const element = event.currentTarget;
    const firstChildElement = element.querySelector('.mega-menu');
    firstChildElement.setAttribute('open', '');
    mega_menu_overlay.style.display = 'block';
  }
  function handleMouseOut(event) {
    const element = event.currentTarget;
    const firstChildElement = element.querySelector('.mega-menu');
    firstChildElement.removeAttribute('open', '');
    mega_menu_overlay.style.display = 'none';
  }

  const overlay = document.querySelector('#mega-menu-overlay');
const searchIcon = document.querySelector('svg.modal__toggle-open.icon.icon-search');
const closeIcon = document.querySelector('svg.icon.icon-close');
const searchInput = document.querySelector('#Search-In-Modal');

// Search icon click → show overlay
searchIcon.addEventListener('click', function (e) {
    e.stopPropagation();
    overlay.style.display = 'block';
});

// Close icon click → hide overlay
closeIcon.addEventListener('click', function (e) {
    e.stopPropagation();
    overlay.style.display = 'none';
});

// Overlay ke andar click hone par body close event trigger na ho
overlay.addEventListener('click', function (e) {
    e.stopPropagation();
});

// Input pe click hone par bhi overlay close na ho
searchInput.addEventListener('click', function (e) {
    e.stopPropagation();
});






  // document.querySelector('svg.modal__toggle-open.icon.icon-search').addEventListener('click', function () {
  //   document.querySelector('#mega-menu-overlay').style.display = 'block';
  // });

  // const mega_menu_overlay = document.querySelector('#mega-menu-overlay');
  // const detailsElements = document.querySelectorAll('header-menu details.mega-menu');

  // detailsElements.forEach((details) => {
  //   details.addEventListener('toggle', () => {
  //     if (details.open) {
  //       mega_menu_overlay.style.display = 'block';
  //     } else {
  //       mega_menu_overlay.style.display = 'none';
  //     }
  //   });
  // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const productSection = document.querySelector('[id^="ProductInfo-"]');
  const stickyData = productSection.dataset.sticky;
  if (stickyData === 'true') {
    var sidebarEl = document.querySelector('.sidebar__inner');
    var sidebar = new StickySidebar(sidebarEl, {
      topSpacing: 40,
      containerSelector: '.product__info-wrapper',
      innerWrapperSelector: '.sidebar__inner-padding',
      resizeSensor: true,
      minWidth: 992,
    });
    sidebarEl.addEventListener('affix.bottom.stickySidebar', function (event) {
      console.log('Sidebar has stuck bottom of viewport.');
    });
  }
  console.log('stickyData', stickyData);
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
      if (stickyData === 'true') {
        sidebar.updateSticky();
      }
    }
  }

  document.querySelectorAll('details.accordion__details').forEach((el) => {
    new Accordion(el);
  });
  // document.querySelector('#locally-modal').addEventListener('click',e=>{
  //   if(e.target == e.currentTarget){
  //     e.target.classList.remove('locally-modal-visible');
  //   }
  // })
  // document.querySelector('#locally-product-locator-btn')?.addEventListener('click',e=>{
  //   e.preventDefault();
  //   document.querySelector('#locally-modal').classList.add('locally-modal-visible')
  // })
  // document.querySelector('.close-locally-modal')?.addEventListener('click',e=>{
  //   e.target.closest('#locally-modal').classList.remove('locally-modal-visible');
  // })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;

            // ⚡ Reinitialize Slick and variant image click handlers
            this.initSliders();
            this.initVariantImageClicks();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 200px 0px'
    }).observe(this);
  }

  // 🔁 Reinitialize Slick sliders
  initSliders() {
    const sliders = this.querySelectorAll('.card-information__variants');

    sliders.forEach(slider => {
      const $slider = $(slider);

      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }

      $slider.slick({
        infinite: false,
        slidesToShow: 7,
        slidesToScroll: 1,
        arrows: true,
        nextArrow: '<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" role="img" width="24px" height="24px" fill="none"><path stroke="currentColor" stroke-width="1.5" d="M8.474 18.966L15.44 12 8.474 5.033"></path></svg></button>',
        prevArrow: '<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" role="img" width="24px" height="24px" fill="none"><path stroke="currentColor" stroke-width="1.5" d="M15.525 18.966L8.558 12l6.967-6.967"></path></svg></button>',
        responsive: [
          {
            breakpoint: 480,
            settings: {
              variableWidth: true
            }
          }
        ]
      });

      $slider.on('init', function (event, slick) {
        if ($slider.find('.slick-arrow').length > 0) {
          $slider.addClass('has-arrows');
        }
      });

      $slider.trigger('init');
    });
  }

  // 🔁 Reinitialize variant image click events
  initVariantImageClicks() {
    const variantImgWrappers = this.querySelectorAll('.card-information__variant-image');

    variantImgWrappers.forEach(variantImgWrapper => {
      variantImgWrapper.addEventListener('click', function (e) {
        e.preventDefault();

        const imgEl = this.querySelector('img');
        if (!imgEl) return;

        const clickedVariantId = this.getAttribute('data-variant-id');
        const productContainer = this.closest('.card-wrapper');
        if (!productContainer) return;

        productContainer.querySelectorAll('.card-information__variant-image').forEach(w => {
          w.classList.remove('current');
        });
        this.classList.add('current');

        productContainer.querySelectorAll('.visually-hidden .variant-btn').forEach(btn => {
          if (btn.getAttribute('data-variant-id') === clickedVariantId) {
            btn.click();
          }
        });

        const featured = imgEl.getAttribute('data-featured');
        const featuredSrcset = imgEl.getAttribute('data-featuredsrcset');
        const hover = imgEl.getAttribute('data-hover');
        const hoversrcset = imgEl.getAttribute('data-hoversrcset');
        const alt = imgEl.getAttribute('alt');

        const cardLink = this.closest('a.card-link');
        if (!cardLink) return;

        const inner = cardLink.querySelector('.card__inner');
        if (!inner) return;

        const mainImg = inner.querySelector('img.card-mainimg');
        const hoverImg = inner.querySelector('img.card-hoverimg');

        if (mainImg && featured) {
          mainImg.src = featured;
          if (featuredSrcset) mainImg.setAttribute('srcset', featuredSrcset);
          if (alt) mainImg.alt = alt;
        }

        if (hoverImg && hover) {
          hoverImg.src = hover;
          if (hoversrcset) hoverImg.setAttribute('srcset', hoversrcset);
        }

        const href = cardLink.getAttribute('href');
        if (href) {
          const [base, query] = href.split('?');
          const tail = query ? '&' + query : '';
          const newHref = base + '?variant=' + clickedVariantId + tail;
          cardLink.setAttribute('href', newHref);
        }
      });
    });
    document.querySelectorAll('.card-information__variants').forEach(div => {
        const parentAnchor = div.closest('a');
        if (parentAnchor) {
            parentAnchor.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
            });
        }
    });
  }
}

customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secondary-page-proprogram"]) return;
  try {
    
  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
      open ? this.el.closest('.page-width').classList.add('accordion-open') : this.el.closest('.page-width').classList.remove('accordion-open');
    }
  }

  document.querySelectorAll('details.accordion__details').forEach((el) => {
    new Accordion(el);
  });

  } catch(e) { console.error(e); }
})();
})();
